// extracted by mini-css-extract-plugin
module.exports = {"container":"progressBar_container__20G57","bar":"progressBar_bar__1yOSN","fill":"progressBar_fill__1CJj9","text":"progressBar_text__2-vRa"};